import { render, staticRenderFns } from "./BillingPortal.vue?vue&type=template&id=24c087d2&"
import script from "./BillingPortal.vue?vue&type=script&lang=js&"
export * from "./BillingPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports